<template>
    <div class="slide">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title" :answers="questions.question.answers" :correctAnswer="questions.question.correctAnswer" :nextRoute="nextRoute" :current="2" :total="3" />
    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: 'trivia-3',
            currentTrivia: 2,
            questions: {
                question: {
                    "title": "The most common theft method for shoplifters at THD is:",
                    "answers": [
                        {"key": "A", "answer": "Concealing on self"},
                        {"key": "B", "answer": "Pretending to be an associate"},
                        {"key": "C", "answer": "Ticket switching"},
                        {"key": "D", "answer": "Walking out"}
                    ],
                    "correctAnswer": ["D"]
                }
            }
        }
    },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>

</style>
